import React, { useEffect, useState } from "react";
import { BusinessInformationIcon, BusinessInformationRedIcon, CreateAccountIcon, PasswordSettingIcon, PasswordSettingRedIcon, PersonalInformationIcon, PersonalInformationRedIcon, ProjExelLogo } from "../../assets/images";
type AppProps = {
  onNext: (data: any) => void;
  activeStep:number;
};
const PersonalInformationForm = ({ onNext , activeStep}: AppProps) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  useEffect(() => {
    let persistedData: any = localStorage.getItem("personalInfo");
    if (persistedData) {
      let parsedData = JSON.parse(persistedData);
      setFirstName(parsedData?.firstName || "");
      setLastName(parsedData?.lastName || "");
    }
  }, []);
  const handleNext = (e: any) => {
    e.preventDefault();
    const data = { firstName, lastName };
    localStorage.setItem("personalInfo", JSON.stringify(data)); // Persist data
    onNext(data); 
  };


  const steps = [
       {
         icon: CreateAccountIcon,
         redIcon: CreateAccountIcon,
       
       },
       {
         icon: PersonalInformationIcon,
         redIcon: PersonalInformationRedIcon,
       
       },
       {
         icon: BusinessInformationIcon,
         redIcon: BusinessInformationRedIcon,
       
       },
       {
         icon: PasswordSettingIcon,
         redIcon: PasswordSettingRedIcon,
      
       },
     ];
  return (
    <>
      <div
        className="main-signup"
      >
        <div className="personal-info-container">

          <div className="logo-section mb-3">
          <img src={ProjExelLogo}  className="company-logo"/>
          <div style={{display:'flex',marginBottom:'30px'}}>
          {steps?.map((step, index) => (
          < >
          
                        <div  key={index} className="step-indicator">
                          <span
                            className={`step${
                              activeStep === index ? "active" : ""
                            }`}
                          >
                            <img
                              src={
                                activeStep === index || activeStep > index
                                  ? step?.redIcon
                                  : step?.icon
                              }
                              alt={' Icon'}
                              // className="left-pannel-image"
                            />
                          </span>
                          <span className="line"></span>
                        </div>
                      
                      </>
                      
                    ))}
                    </div>
                    
                            </div>

       
          <h5 className="mt-4 right-panel-heading">Personal Information</h5>
          <span className="right-panel-subHeading">
            Enter your details below to get started.
          </span>
          <form>
            <div className="form-group mt-3">
              <div>
                <label htmlFor="foldername">
                  First Name<span className="color-red">*</span>
                </label>
                <input
                  type={"text"}
                  className={"form-control mb-3"}
                  name="text"
                  value={firstName}
                  autoFocus
                  onChange={(e) => setFirstName(e.target.value)}
                  maxLength={60}
                />
            
                <label htmlFor="foldername">
                  Last Name<span className="color-red">*</span>
                </label>
                <input
                  type={"text"}
                  className={"form-control mb-3"}
                  name="text"
                  value={lastName}
                  // autoFocus
                  onChange={(e) => setLastName(e.target.value)}
                  maxLength={60}
                />
                <div
                  className="mb-3 mt-3 d-flex"
                  style={{ float: "inline-end" }}
                >
                  <button
                    type="submit"
                    className="btn btn-primary"
                    style={{ width: "94px" }}
                    disabled={!firstName?.trim() || !lastName?.trim()}
                    onClick={(e) => handleNext(e)}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </form>
          <p className="mobileCopyright">
                &copy; Copyright 2025 | AKSSAI ProjExel | All right reserved
              </p>
        </div>
      </div>
    </>
  );
};

export default PersonalInformationForm;
